import {createUseStyles} from 'react-jss'

export default createUseStyles({
  dotsOpts: {
    backgroundColor: 'white',
    position: 'absolute',
    top: 40,
    borderRadius: 5,
    borderBottom: 'none',
    boxShadow: '0 3px 6px rgba(0,0,0,0.5)',
    right: -2,
    display:'flex',
    flexDirection: 'column',
    animation: '$slide 0.5s',
    zIndex: 99,
    // overflow: "hidden",

    minWidth: 150,
    '&::after': {
      content: "''",
      position: 'absolute',
      right: 8,
      top: -8,
      height: 15,
      width: 15,
      // borderTop: '1px solid  rgba(0,0,0,0.2)',
      // borderLeft: '1px solid  rgba(0,0,0,0.2)',
      boxShadow: '0 3px 6px rgba(0,0,0,0.5)',
      transform: 'rotate(45deg)',
      backgroundColor: 'white',
      zIndex: 2
    },

    "& a:first-child": {
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
    },

    "& a:last-child": {
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
      borderBottom: "none !important"
    },
    '& a': {
      borderBottom: '1px solid rgba(0,0,0,0.2)',
      fontSize: 14,
      width: '100%',
      padding: '15px 10px',
      color: 'rgba(0,0,0,0.7)',
      cursor: 'pointer',
      backgroundColor: "white",
      whiteSpace: 'nowrap',
      zIndex: 3,
      
      '&:hover': {
        backgroundColor: '#dbdbdb'
      }
    }
  },


  '@keyframes slide': {
    from: {opacity: 0, top: 35},
    to: {opacity: 1, }
  }
})